var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Publishable = /** @class */ (function () {
    function Publishable() {
        this.id = null;
    }
    Publishable.prototype.isToPublish = function () {
        if (this.status !== Publishable.STATUS_PUBLISHED)
            return false;
        switch (this.original.status) {
            case Publishable.STATUS_DRAFT:
            case Publishable.STATUS_SCHEDULED:
            case Publishable.STATUS_SCHEDULED_PREORDER:
            case Publishable.STATUS_SCHEDULED_COMING_SOON:
                return true;
            default:
                return false;
        }
    };
    Publishable.prototype.wasScheduled = function () {
        switch (this.original.status) {
            case Publishable.STATUS_SCHEDULED:
            case Publishable.STATUS_SCHEDULED_PREORDER:
            case Publishable.STATUS_SCHEDULED_COMING_SOON:
                return true;
            default:
                return false;
        }
    };
    Publishable.prototype.isToSchedule = function () {
        return false;
    };
    Publishable.prototype.isToUnPublish = function () {
        return this.original.status === Publishable.STATUS_PUBLISHED
            && this.status === Publishable.STATUS_DRAFT;
    };
    Publishable.prototype.isToRestore = function () {
        return this.original.status === Publishable.STATUS_REMOVED
            && this.status === Publishable.STATUS_DRAFT;
    };
    Publishable.prototype.isToAdd = function () {
        return this.original.status === Publishable.STATUS_NEW;
    };
    Publishable.prototype.isToRemove = function () {
        return this.status === Publishable.STATUS_REMOVED;
    };
    Publishable.prototype.remove = function () {
        this.status = Publishable.STATUS_REMOVED;
    };
    Publishable.prototype.isPublished = function () {
        return this.status === Publishable.STATUS_PUBLISHED;
    };
    Publishable.prototype.copyFromOriginal = function () {
        var item = this.original;
        this.id = item.id;
        this.status = item.status;
    };
    Publishable.prototype.hasChanged = function () {
        var orig = this.original;
        return orig && (this.status !== orig.status);
    };
    Publishable.STATUS_NEW = "New";
    Publishable.STATUS_DRAFT = "Draft";
    Publishable.STATUS_PUBLISHED = "Published";
    Publishable.STATUS_REMOVED = "Removed";
    Publishable.STATUS_SCHEDULED = "Scheduled";
    Publishable.STATUS_SCHEDULED_PREORDER = "ScheduledPreOrder";
    Publishable.STATUS_SCHEDULED_COMING_SOON = "ScheduledComingSoon";
    return Publishable;
}());
var OrderedPublishable = /** @class */ (function (_super) {
    __extends(OrderedPublishable, _super);
    function OrderedPublishable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OrderedPublishable.prototype.getOriginal = function () {
        return this.original ? this.original : null;
    };
    //Don't include order change in hasChanged.
    OrderedPublishable.prototype.hasChanged = function () {
        if (!_super.prototype.hasChanged.call(this)) {
            var orig = this.getOriginal();
            return orig && (this.isForWeb !== orig.isForWeb
                || this.isForApp !== orig.isForApp
                || this.isHeroBanner !== orig.isHeroBanner);
        }
        return true;
    };
    OrderedPublishable.prototype.hasChangedOrder = function () {
        var _a;
        return ((_a = this.getOriginal()) === null || _a === void 0 ? void 0 : _a.order) !== this.order;
    };
    OrderedPublishable.prototype.copyFromOriginal = function () {
        _super.prototype.copyFromOriginal.call(this);
        var item = this.getOriginal();
        this.isForApp = item.isForApp;
        this.isForWeb = item.isForWeb;
        this.isHeroBanner = item.isHeroBanner;
        this.order = item.order;
    };
    OrderedPublishable.prototype.getItemReOrder = function () {
        return {
            id: this.id,
            oldOrder: this.getOriginal().order,
            newOrder: this.order
        };
    };
    return OrderedPublishable;
}(Publishable));
var ItemOrder = /** @class */ (function () {
    function ItemOrder() {
    }
    return ItemOrder;
}());
export { Publishable, ItemOrder, OrderedPublishable };
